// ShareBite core domain types and data-model interfaces.
//
// This module is the single source of truth for ShareBite's literal unions and
// entity shapes. It is pure TypeScript with no Firebase or platform dependency,
// so the same definitions compile for the browser bundle (app) and the Cloud
// Functions runtime (packages/functions).
//
// Design reference: design.md "Data Models".
// Requirements: 6.1 (exactly three Food Categories), 15.1 (exactly seven
// Donation Statuses), 26.5 (Google UID identity model).
// ---------------------------------------------------------------------------
// Canonical sets
// ---------------------------------------------------------------------------
/**
 * The canonical set of exactly three Food Categories (Req 6.1).
 * Order is stable; values are exact and case-sensitive.
 */
export const FOOD_CATEGORIES = [
    "Vegetarian",
    "Eggetarian",
    "Non-Vegetarian",
];
/**
 * The canonical set of exactly seven Donation Statuses (Req 15.1), in
 * lifecycle order. No other statuses exist.
 */
export const DONATION_STATUSES = [
    "Draft",
    "Available",
    "Reserved",
    "Collected",
    "Completed",
    "Expired",
    "Cancelled",
];
//# sourceMappingURL=types.js.map